// constants.js или в основном файле
export const MSK_OFFSET_HOURS = 0;
export const MSK_OFFSET_MS = MSK_OFFSET_HOURS * 60 * 60 * 1000;

/**
 * Преобразует ISO дату в Unix timestamp (секунды) в часовом поясе МСК
 * @param {string} isoDate - дата в формате ISO 8601 (например, "2026-08-13T15:40:00.000Z")
 * @returns {number} Unix timestamp в секундах
 */
export function isoToUnixMsk(isoDate) {
    const date = new Date(isoDate);
    const utcTimestamp = date.getTime();
    const mskTimestamp = utcTimestamp + MSK_OFFSET_MS;
    return Math.floor(mskTimestamp / 1000);
}

/**
 * Преобразует Unix timestamp обратно в ISO дату в часовом поясе МСК
 * @param {number} unixTimestamp - Unix timestamp в секундах
 * @returns {string} ISO дата в формате "YYYY-MM-DDTHH:mm:ss.000Z" в МСК
 */
export function unixToIsoMsk(unixTimestamp) {
    const mskTimestamp = unixTimestamp * 1000;
    const utcTimestamp = mskTimestamp - MSK_OFFSET_MS;
    const date = new Date(utcTimestamp);
    return date.toISOString();
}
/**
 * Получить текущий Unix timestamp в МСК
 * @returns {number} Текущий Unix timestamp в секундах
 */
export function getCurrentUnixMsk() {
    const now = new Date();
    return isoToUnixMsk(now.toISOString());
}

/**
 * Получить текущую ISO дату в МСК
 * @returns {string} Текущая ISO дата в МСК
 */
export function getCurrentIsoMsk() {
    const now = new Date();
    return unixToIsoMsk(Math.floor(now.getTime() / 1000));
}

// Секунды unix (могут быть дробными) <-> Date для DatePicker
export function unixToDate(unixTimestamp) {
    return unixTimestamp == null ? null : new Date(unixTimestamp * 1000);
}
export function dateToUnix(date) {
    return date ? new Date(date).getTime() / 1000 : null;
}

// Экспорт по умолчанию для удобства импорта всех функций
export default {
    MSK_OFFSET_HOURS,
    MSK_OFFSET_MS,
    isoToUnixMsk,
    unixToIsoMsk,
    getCurrentUnixMsk,
    getCurrentIsoMsk
};